import React, { Component } from "react";

import { CadastroForm } from './components/cadastro_form'


export default class CadastroSMS extends React.Component {

    render() {
        return (
            <React.Fragment>
                <CadastroForm />
            </React.Fragment>
        )
    }
}


// WEBPACK FOOTER //
// ./src/pages/Sms/Cadastro/index.js